import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/shared/ui/button';
import { PublicSurveyTopBar } from './public-survey-top-bar';

export function PublicSurveyConfirmPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const reduceMotion = useReducedMotion();
  const returnTo = params.get('returnTo');

  useEffect(() => {
    const timer = window.setTimeout(() => {
      if (returnTo) navigate(returnTo);
      else navigate(-1);
    }, 5000);
    return () => window.clearTimeout(timer);
  }, [navigate, returnTo]);

  return (
    <div className="flex flex-1 flex-col bg-background">
      <PublicSurveyTopBar />
      <div className="flex flex-1 flex-col items-center justify-center px-4">
        <motion.div
          className="flex max-w-md flex-col items-center gap-6 text-center"
          initial={reduceMotion ? { opacity: 0 } : { opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <CheckCircle2 className="size-20 text-success" strokeWidth={1.5} />
          <div className="space-y-2">
            <h1 className="text-2xl font-semibold tracking-tight">{t('confirm.title')}</h1>
            <p className="text-muted-foreground">
              {t('confirm.description')}
              <br />
              {t('confirm.thanks')}
            </p>
          </div>
          <Button variant="secondary" onClick={() => (returnTo ? navigate(returnTo) : navigate(-1))}>
            {t('confirm.backButton')}
          </Button>
          <p className="text-xs text-muted-foreground">{t('confirm.redirect')}</p>
        </motion.div>
      </div>
    </div>
  );
}
